// config/themes/slot.theme.ts
import { Theme } from './ITheme';

const slotTheme: Theme = {
  colors: {
    background: '#3f3febff', // dark blue background
    background2: '#2A2A3D', // secondary background
    background4: '#3A3A4D', // additional background layer
    slider: '#5cf20cff', // slider color
    text2: '#CCCCCC', // secondary text color
    autoplayBtBgborder: '#5cf20c33', // autoplay button border
    qbet: '#5cf20cff', // quick bet color
    primary: '#5cf20cff', // gold for highlights
    secondary: '#30cee7ff', // red accent
    text: '#FFFFFF', // white text
    overlay: 'rgba(27,27,47,0.8)', // semi-transparent overlay
    border: '#5cf20c33', // gold border with transparency
    betborder: '#5cf20c33', // bet border color
    betborderPress: '#4acc0a', // bet border press color
    betbutton: '#2A2A3D', // bet button background
    stake: '#5cf20cff', // stake color
    betHover: '#5cf20c66', // bet hover color
    betButtonHover: '#6fff1d', // bet button hover color
    betButtonPress: '0 0 0 0.2rem rgba(92, 242, 12, 0.5)', // bet button press shadow
    betCancelHover: '#ff4444', // bet cancel hover color
    betCancelPress: '0 0 0 0.2rem rgba(255, 68, 68, 0.5)', // bet cancel press shadow
    betCancelPressMobile: '#cc3636', // bet cancel press mobile color
    betCashHover: '#7fff2e', // bet cash hover color
    betCashPress: '0 0 0 0.2rem rgba(127, 255, 46, 0.5)', // bet cash press shadow
    betCashPressMobile: '#66cc25', // bet cash press mobile color
    betButtonPressMobile: '#58cc0f', // bet button press mobile color
    success: '#e992f9ff',
    warning: '#a72fd3ff',
    danger: '#eaff00ff',
  },
  fonts: {
    primary: 'Montserrat, sans-serif',
    secondary: 'Arial, sans-serif',
    button: 'Montserrat, sans-serif',
  },
  uiElements: {
    button: {
      borderRadius: '6px',
      padding: '12px 20px',
      fontSize: '16px',
    },
    card: {
      borderRadius: '10px',
      shadow: '0 4px 8px rgba(0,0,0,0.15)',
    },
    modal: {
      borderRadius: '14px',
      background: '#2A2A3D',
    },
    spacing: { padding: '16px', margin: '16px' },
  },
};

export default slotTheme;
